'use client';

import { FC } from 'react';
import AppsShelve from './apps-shelve/apps-shelve';
import { OwShelf } from '../../interfaces/domain/ow-app-shelf.modal';
import BannersShelve from './banners-shelve/banners-shelve';

interface ShelveProps {
  shelveData: OwShelf;
}

// -----------------------------------------------------------------------------
const Shelve: FC<ShelveProps> = props => {
  const {
    shelveData
  } = props;

  if (!shelveData.type) {
    return null;
  }

  return (
    <>
      {shelveData.type === 'app' &&
        <AppsShelve appsData={shelveData} />
      }

      {shelveData.type === 'banner' &&
        <BannersShelve bannersData={shelveData} />
      }
    </>
  );
};

export default Shelve;